// Connection.js
// export const main_link = "http://127.0.0.1:8000/api/";
export const main_link = "https://shawns-backend.tarrasoft.info/api/";
export const isAdmin =
  sessionStorage.getItem("role_2") ===
  "muiwvev934v83489@5jrdmr-u238u23c++ru232cmi3-4t83t34cjrm892E3urc@283"
    ? true
    : false;

// export const main_link = "http://192.168.0.109:8000/api/";
